import React from 'react'
import { Table, TableBody, TableCell, TableHeader, TableRow } from './ui/table'
import { tanstackTableTheme } from '../contexts/ThemeContext'
import { Skeleton } from './ui/skeleton'

const TableSkeleton = ({columns, rows, headers}) => {
  return (
    <>
        <Table className="rounded-md overflow-hidden border">
            <TableHeader>
                <TableRow key={0} className={tanstackTableTheme}>
                {[...Array(columns)].map((_, idx) => (
                    <TableCell key={idx} className="font-bold cursor-pointer">
                        {headers[idx] || "Data" }
                    </TableCell>
                ))}
                </TableRow>
            </TableHeader>
            <TableBody>
                {[...Array(rows)].map((_, idx) => (
                <TableRow key={idx}>
                    {[...Array(columns)].map((_, idx1) => (
                    <TableCell key={idx1} className={`${idx1 === 0 && 'w-[70px]'}`} >
                        <Skeleton className={`h-5`} />
                    </TableCell>
                    ))}
                </TableRow>
                ))}
            </TableBody>
        </Table>
    </>
  )
}

export default TableSkeleton